import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import PanelBarItemT from '@/Controls/PanelBarItem';

export default class PanelBarItemsBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.panelBarItems = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let PanelBarItem = ComponentManager.getControl<typeof PanelBarItemT>('PanelBarItem');

                let panelBar = $(element);
                let options = valueAccessor();
                let items = options.items;
                let parent = options.parent;
                let widget = options.widget();

                function onItemsChange(items) {
                    panelBar.find('li').each(function () {
                        widget.remove($(this));
                    });

                    parent.elements = [];

                    for (let i = 0; i < items.length; i++) {
                        let panelBarRef = widget.append({ text: '' }, panelBar);

                        let panelBarItem;
                        if (panelBar.find('.k-group').length > 0) {
                            panelBarItem = panelBar.find('.k-group .k-item').last();
                        } else {
                            panelBarItem = panelBar.children('.k-item').last();
                        }
                        
                        let panelBarItemControl = new PanelBarItem(items[i], panelBarItem);

                        let tuple = panelBarItemControl.getTuple();

                        parent.elements.push(panelBarItemControl);
                    }
                }

                let subscription = items.subscribe(onItemsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(panelBar[0], () => {
                    subscription.dispose();
                });
                onItemsChange(items());
            }
        };
    }
}